module.exports = __webpack_public_path__ + "static/media/4.2dfb6759.jpg";